import axios from 'axios';

import { AppDispatch } from '../../reducer/store';
import { getToken } from '../axiosToken';

import {
	reducerGetProjects,
	reducerGetProjectsFilters,
	reducerGetSimplifiedListProjects,
} from '../../reducer/projects/reducers/reducerProjectsList';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const actionGetProjectsList =
	(limit: number, offset: number) =>
	async (dispatch: AppDispatch, getState: () => any) => {
		const { token } = await getToken();
		axios.defaults.headers.common['Authorization'] = token;

		const store = getState();
		const filter = store.projects.projects.projectsInputValues;

		try {
			const response = await axios.post(`${BASE_URL}/json/projects/list`, {
				limit,
				page: offset,
				managers: [filter.managers],
				...filter,
			});
			dispatch(reducerGetProjects({ data: response.data }));
		} catch (e: any) {
			if (e.response && e.response.status === 401) {
				window.location.href = "/login";
			}
		}
	};

export const actionGetSimplifiedProjectsList =
	(limit: number, offset: number) =>
	async (dispatch: AppDispatch, getState: () => any) => {
		const { token } = await getToken();
		axios.defaults.headers.common['Authorization'] = token;

		try {
			const response = await axios.get(`${BASE_URL}/json/contracts/budget/form`);
			dispatch(reducerGetSimplifiedListProjects({ data: response.data }));
		} catch (e: any) {
			if (e.response && e.response.status === 401) {
				window.location.href = "/login";
			}
		}
	};

export const actionGetProjectsFilters = () => async (dispatch: AppDispatch) => {
	const { token } = await getToken();
	axios.defaults.headers.common['Authorization'] = token;
	try {
		const response = await axios.get(`${BASE_URL}/json/projects/list/filters`);
		dispatch(reducerGetProjectsFilters(response.data));  
	} catch {
		console.log('err');
	};
};
